import {apiFetch} from "../../api";
import {BASE_URL as u} from "../../../commonUrls";

const BASE_URL = `${u}/tag`;
//const USER_ID = "u-c136202b-94f4-4e51-aa0b-72db0503c362";

export async function getAllTags() {
  const res = await apiFetch(`${BASE_URL}/userId`);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
  //http://localhost:8082/api/tag/userId/u-c136202b-94f4-4e51-aa0b-72db0503c362
  //http://localhost:8080/api/tag/userId/u-c136202b-94f4-4e51-aa0b-72db0503c362
}

export async function createTag(tagName) {
  const payload = { userId: 0, tagName };

  const res = await apiFetch(BASE_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) throw new Error("Failed to create tag");
  return res.json();
}

export async function deleteTag(id) {
  const res = await apiFetch(`${BASE_URL}/${id}`, { method: "DELETE" });
  if (!res.ok) throw new Error("Failed to delete tag");
}

export async function updateTag(id, tagName) {
  const payload = { userId: 0, tagName };

  const res = await apiFetch(`${BASE_URL}/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) throw new Error("Failed to update tag");
  return res.json();
}
